import { Grid2, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from 'components/AuthProvider'
import Button from 'components/Button'
import { personalDetailsPath } from 'components/Routes'
import DefaultLayout from 'components/layout/DefaultLayout'
import { useMutateDisableTwoFa } from 'hooks/useTwoFa'

export default function DisableAuthenticator(): JSX.Element {
  const { user, maybeRequestOtp, setToast, refreshCurrentUser } = useAuth()
  const navigate = useNavigate()
  const [
    disableAuthenticatorAppRequested,
    setDisableAuthenticatorAppRequested
  ] = useState(false)

  const disableTwoFaMutation = useMutateDisableTwoFa()

  const disableAuthenticatorApp = () => {
    disableTwoFaMutation.mutate(undefined, {
      onSuccess: () => {
        void refreshCurrentUser()
        setToast({
          open: true,
          message: 'Good as gold! Authenticator app disabled.',
          type: 'success',
          duration: 3000
        })
        navigate(personalDetailsPath())
      },
      onError: (error: unknown) => {
        setToast({
          open: true,
          message:
            error instanceof Error
              ? error.message
              : 'Failed to disable authenticator',
          type: 'error',
          duration: 3000
        })
      }
    })
  }

  useEffect(() => {
    if (disableAuthenticatorAppRequested && user?.otpVerified) {
      disableAuthenticatorApp()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableAuthenticatorAppRequested, user])

  const handleDisableAuthenticatorApp = () => {
    if (user?.otpVerified) {
      disableAuthenticatorApp()
    } else {
      setDisableAuthenticatorAppRequested(true)
      maybeRequestOtp()
    }
  }

  const loading = !user || disableTwoFaMutation.isLoading

  return (
    <DefaultLayout
      backgroundColor='default'
      heading='Disable'
      showBackIcon
      loading={loading}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12 }}>
          <Typography>
            You currently have the authenticator app enabled, click the button
            below to turn it off.
          </Typography>
        </Grid2>
        <Grid2 sx={{ mt: 4, textAlign: 'center' }} size={{ xs: 12 }}>
          <Button color='blue' onClick={handleDisableAuthenticatorApp}>
            Turn off authenticator app
          </Button>
        </Grid2>
      </Grid2>
    </DefaultLayout>
  )
}
